import {cn} from "./utils";
import * as React from "react";

function Skeleton({className, style, ...props}: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="skeleton"
            className={cn("animate-pulse rounded-md", className)}
            style={{
                backgroundColor:
                    "color-mix(in srgb, var(--foreground) 14%, var(--surface))",
                ...style,
            }}
            {...props}
        />
    );
}

export {Skeleton};
